import { EListingOffersActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setPage = actionGenerator<EListingOffersActionType.SetPage, number>(EListingOffersActionType.SetPage);
